import { DELETE, PATCH, POST } from "lib/core/api"

export const createNoteApi = ({
  calendarYear,
  content,
  forwardLooking,
  schoolId,
  subjectId,
  yearTime,
}: {
  calendarYear: number
  content: string
  forwardLooking: boolean
  schoolId: number
  subjectId: number
  yearTime: string
}) =>
  POST("/school-notes/", {
    calendarYear,
    content,
    forwardLooking,
    school: schoolId,
    subject: subjectId,
    yearTime,
  })

export const updateNoteApi = ({
  noteId,
  content,
}: {
  noteId: number
  content: string
}) =>
  PATCH(`/school-notes/${noteId}`, {
    content,
  })

export const deleteNoteApi = ({ noteId }: { noteId: number }) =>
  DELETE(`/school-notes/${noteId}`)

export const enableOutflowProfileApi = ({
  schoolId,
  grade,
}: {
  schoolId: number
  grade: number
}) =>
  POST(`/schools/${schoolId}/enable_outflow_profile/`, { year_grade: grade })

export const disableOutflowProfileApi = ({
  schoolId,
  grade,
}: {
  schoolId: number
  grade: number
}) => DELETE(`/schools/${schoolId}/disable_outflow_profile/${grade}/`)
